import { render, staticRenderFns } from "./activity-create.vue?vue&type=template&id=57838670&scoped=true&"
import script from "./activity-create.vue?vue&type=script&lang=js&"
export * from "./activity-create.vue?vue&type=script&lang=js&"
import style0 from "./activity-create.vue?vue&type=style&index=0&id=57838670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57838670",
  null
  
)

component.options.__file = "activity-create.vue"
export default component.exports